import { render, staticRenderFns } from "./StockInfoSidebar.vue?vue&type=template&id=d84cc682"
import script from "./StockInfoSidebar.vue?vue&type=script&lang=js"
export * from "./StockInfoSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports